module.exports = __webpack_public_path__ + "static/img/5.0d2234c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/5.png
// module id = vzey
// module chunks = 0